<template>
  <div
    class="scroll_flex_container"
    v-loading="loading"
    :element-loading-text="loadingText"
  >
    <div
      class="column_center_start px-5 py-8"
      style="width: 100%; flex-grow: 1; background-color: #f0f0f0"
      v-if="!loading"
    >
      <div class="column_center_start">
        <paymentStatus :orderInfo="orderInfo" :orderNumber="orderNumber" />
        <!-- 根據需求隱藏取消訂單按鈕 -->
        <!-- <button class="cancel_button" @click="cancelOrder" v-if="paymentUnprocessed || paymentProcessing">取消訂單</button> -->
        <text class="title" style="font-size: 24px" v-if="isDineIn">
          <span class="text-primary-color">門市內用</span
          ><span> / 編號：{{ orderNumberTrailing }}</span>
        </text>
        <text class="title" style="font-size: 24px" v-if="isDineIn && table"
          >桌號：{{ table }}</text
        >
        <text class="title" style="font-size: 24px" v-if="isTakeOut">
          <span class="text-primary-color">現場外帶</span
          ><span> / 編號：{{ orderNumberTrailing }}</span>
        </text>
        <text class="title" style="font-size: 24px" v-if="isTakeOut && table"
          >桌號：{{ table }}</text
        >
        <text class="title" style="font-size: 24px" v-if="isPickUp">
          <span class="text-primary-color">預約自取</span
          ><span> / 編號：{{ orderNumberTrailing }}</span>
        </text>
        <text class="title" style="font-size: 24px" v-if="isDelivery">
          <span class="text-primary-color">店家外送</span
          ><span> / 編號：{{ orderNumberTrailing }}</span>
        </text>
        <text class="title" style="font-size: 24px" v-if="isRetailPickUp">
          <span class="text-primary-color">零售自取</span
          ><span> / 編號：{{ orderNumberTrailing }}</span>
        </text>
        <text class="title" style="font-size: 24px" v-if="isRetailDelivery">
          <span class="text-primary-color">零售宅配</span
          ><span> / 編號：{{ orderNumberTrailing }}</span>
        </text>
      </div>
      <div class="order_list">
        <div class="column_start_start order_list_detail">
          <div
            class="row_center_between"
            style="width: 100%; padding: 10px 0 20px"
          >
            <text class="title">商品列表</text>
          </div>
          <div class="column_center_start" style="width: 100%">
            <OrderList
              v-for="(product, index) in cartList"
              :product="product"
              :key="index"
              @deleteProduct="deleteProduct(index)"
            ></OrderList>
          </div>

          <div
            class="column_end_start total_price"
            :style="{ borderTop: paymentDisplayServiceFee || isDeliveryType }"
          >
            <div class="row_center_center">
              <text>商品小計：</text>
              <text class="text-primary-color">${{ paymentTotalPrice }}</text>
            </div>
            <div
              class="row_center_center mt-2.5"
              v-if="paymentDisplayServiceFee && !isDeliveryType"
            >
              <text>服務費：</text>
              <text class="text-primary-color">{{
                paymentDisplayServiceFee
              }}</text>
            </div>
            <!-- 運費顯示（外送訂單永遠顯示） -->
            <div class="row_center_center mt-2.5" v-if="isDeliveryType">
              <text>運費：</text>
              <text class="text-primary-color"
                >${{ paymentDisplayShippingFee }}</text
              >
              <text
                v-if="freeShipping > 0 && paymentDisplayShippingFee == 0"
                style="font-size: 14px; color: #4caf50; margin-left: 8px"
              >
                (已達免運門檻)
              </text>
              <text
                v-else-if="freeShipping > 0"
                style="font-size: 14px; color: #999; margin-left: 8px"
              >
                (滿${{ freeShipping }}免運)
              </text>
            </div>
            <div
              class="row_center_center"
              style="margin: 10px 0"
              v-if="usedPointsValue > 0"
            >
              <text>紅利積分折抵：</text>
              <text class="text-primary-color">-{{ usedPointsValue }}</text>
            </div>
            <div class="row_center_center" v-if="false">
              <text>優惠卷：</text>
              <text class="text-primary-color">-{{ usedCouponValue }}</text>
            </div>
          </div>
          <div class="row_center_end" style="width: 100%">
            <div
              class="row_center_center payment_type"
              :style="{
                backgroundColor: isCashPay
                  ? '#FBCB02'
                  : isLinePay
                  ? '#03BF5B'
                  : 'initial',
                color: isLinePay ? '#fff' : 'initial',
              }"
            >
              <text>{{ displayPaymentType }}</text>
            </div>
            <text class="title" style="font-size: 24px">總金額：</text>
            <text class="title text-primary-color" style="font-size: 24px"
              >${{ paymentPrice }}</text
            >
          </div>
        </div>
        <ConsumptionModeDetails :consumptionMethod="consumptionMethod" />
        <!-- 上排：返回店家LINE官方帳號（綠）／返回會員VIP卡（橘） -->
        <div class="flex items-center justify-between w-full px-[6%]">
          <button
            class="button mt-5 mb-2.5"
            style="
              background-color: #06c755;
              color: #fff;
              font-weight: 500;
              font-size: 16px;
              width: 48%;
            "
            @click="toLineOfficialAccount"
            v-if="lineOfficialAddress"
          >
            返回店家LINE@
          </button>
          <button
            class="button mt-5 mb-2.5"
            style="
              background-color: #fd5001;
              color: #fff;
              font-weight: 500;
              font-size: 16px;
            "
            @click="toMemberPage"
            :style="{ width: lineOfficialAddress ? '48%' : '100%' }"
          >
            返回會員VIP卡
          </button>
        </div>
        <!-- 下排：重新支付（付款失敗時才顯示） -->
        <div
          class="flex items-center justify-center w-full px-[6%]"
          v-if="onlinePaymentFailed"
        >
          <button
            class="button mb-2.5"
            style="
              background-color: #fbcb02;
              color: #000;
              font-weight: 500;
              width: 100%;
            "
            @click="toOrderConfirm"
          >
            重新支付
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import orderList from "@/components/store/orderList.vue";
import commonUtilities from "@/utils/common.utils";
import ConsumptionModeDetails from "@/components/store/ConsumptionModeDetails.vue";
import { mapGetters } from "vuex";
import paymentStatus from "@/components/store/paymentStatus.vue";
export default {
  components: {
    OrderList: orderList,
    ConsumptionModeDetails: ConsumptionModeDetails,
    paymentStatus: paymentStatus,
  },
  data() {
    return {
      loading: true,
      fetchOrderInfo: true,
      orderInfoInterval: null,
      orderInfo: {},
      loadingText: "訂單建立中...",
    };
  },
  async created() {
    if (this.showOrderCreateToast) {
      this.loadingText = "訂單建立中...";
    } else {
      this.loadingText = "訂單讀取中...";
    }
    try {
      if (this.useOnlinePayment) {
        await this.fetchLinePayConfirm();
      }
      await this.getOrderInfo();
    } catch (e) {
      console.error("付款頁初始化失敗", e);
    } finally {
      this.loading = false;
      this.startFetchingOrderInfo();
    }
  },
  computed: {
    orderNumber() {
      return (
        this.$store.state.order.orderNumber || this.routerParamsOrderNumber
      );
    },
    routerParamsOrderNumber() {
      return this.getUrlParameters.orderNumber;
    },
    routerQueryOrderNumber() {
      return this.$route.query.orderId;
    },
    orderNumberTrailing() {
      return this.orderNumber.slice(-3);
    },
    getPayment() {
      return this.$store.state.cart.payment;
    },
    address() {
      return this.getPayment.address;
    },
    phone() {
      return this.getPayment.phone;
    },
    paymentServiceFee() {
      return this.getPayment.serviceFee;
    },
    paymentDisplayServiceFee() {
      return this.getPayment.displayServiceFee;
    },
    // 運費相關
    paymentShippingFee() {
      return this.getPayment.shippingFee || 0;
    },
    paymentDisplayShippingFee() {
      return this.getPayment.displayShippingFee || "0";
    },
    paymentTotalPrice() {
      return this.getPayment.totalPrice;
    },
    paymentPrice() {
      return this.getPayment.paymentPrice;
    },
    cartList() {
      // TODO: 使用 this.orderInfo.order_content
      return this.getPayment.cart;
    },
    comments() {
      return this.getPayment.comment;
    },
    usedCouponValue() {
      return this.getPayment.couponTotalValue;
    },
    invoiceType() {
      return this.getPayment.invoiceType.type;
    },
    invoice() {
      return this.getPayment.invoiceType.invoiceNumber;
    },
    paymentType() {
      return this.getPayment.paymentType;
    },
    pickupDate() {
      return this.getPayment.pickupDate;
    },
    pickupTime() {
      return this.getPayment.pickupTime;
    },
    usedPointsValue() {
      return this.getPayment.pointQuantity;
    },
    storeCode() {
      return this.$store.getters["userData/storeCode"];
    },
    getUrlParameters() {
      return this.$route.params;
    },
    table() {
      if (!this.areaId && this.tableIndex == -1) return "";
      return this.$store.getters["cart/tableName"];
    },
    areaId() {
      return this.getUrlParameters.areaId;
    },
    tableIndex() {
      return this.getUrlParameters.tableIndex === undefined ||
        this.getUrlParameters.tableIndex == ""
        ? -1
        : this.getUrlParameters.tableIndex;
    },
    isDelivery() {
      return this.getUrlParameters.method === "delivery";
    },
    isRetailDelivery() {
      return this.getUrlParameters.method === "retailDelivery";
    },
    isDeliveryType() {
      return this.isDelivery || this.isRetailDelivery;
    },
    isPickUp() {
      return this.getUrlParameters.method === "pickUp";
    },
    isRetailPickUp() {
      return this.getUrlParameters.method === "retailPickUp";
    },
    isPickUpType() {
      return this.isPickUp || this.isRetailPickUp;
    },
    isDineIn() {
      return this.getUrlParameters.method === "dineIn";
    },
    isTakeOut() {
      return this.getUrlParameters.method === "takeOut";
    },
    // 統一的消費模式字串，與 ConsumptionModeInfo 保持一致
    consumptionMethod() {
      return this.getUrlParameters.method;
    },
    paymentUnprocessed() {
      return this.paymentStatus === "unprocessed";
    },
    paymentUserCancelled() {
      return this.paymentStatus === "userCancelled";
    },
    paymentProcessing() {
      return this.paymentStatus === "processing";
    },
    paymentPaid() {
      return this.paymentStatus === "paid";
    },
    paymentStoreCancelled() {
      return this.paymentStatus === "storeCancelled";
    },
    isLinePay() {
      return this.paymentType === "linePay";
    },
    isCashPay() {
      return this.paymentType === "cash";
    },
    displayPaymentType() {
      if (this.isLinePay) return "LinePay";
      if (this.isCashPay && this.isRetailDelivery) return "店家自訂";
      if (this.isCashPay && this.isRetailPickUp) return "店家自訂";
      if (this.isCashPay && this.isDelivery) return "取餐付款";
      if (this.isCashPay && this.isPickUpType) return "櫃檯結帳";
      return "櫃檯結帳";
    },
    showOrderCreateToast() {
      return this.$store.state.order.showOrderCreateToast;
    },
    ...mapGetters("payment", {
      linePayPaymentMethod: "linePayPaymentMethod",
    }),
    ...mapGetters("basic", {
      freeShipping: "freeShipping",
      lineOfficialAddress: "lineOfficialAddress",
    }),
    transactionId() {
      return this.$route.query.transactionId;
    },
    useOnlinePayment() {
      return this.orderInfo.use_online_payment === 1 || this.transactionId;
    },
    paymentStatus() {
      // 訂單狀態 order_status
      // 0: 未處理
      // 1: 使用者取消
      // 2: 處理中
      // 3: 已結帳
      // 4: 店家取消訂單
      switch (this.orderInfo.order_status) {
        case 0:
          return "unprocessed";
        case 1:
          return "userCancelled";
        case 2:
          return "processing";
        case 3:
          return "paid";
        case 4:
          return "storeCancelled";
        default:
          return "processing";
      }
    },
    onlinePaymentStatus() {
      return this.orderInfo.online_payment_status;
    },
    linePayUnpaid() {
      return this.onlinePaymentStatus === 0;
    },
    linePayPaid() {
      return this.onlinePaymentStatus === 1;
    },
    linePayCancelled() {
      return this.onlinePaymentStatus === 2;
    },
    linePayProcessing() {
      return this.onlinePaymentStatus === 3;
    },
    linePayFailed() {
      return this.onlinePaymentStatus === 5;
    },
    onlinePaymentFailed() {
      return this.linePayCancelled || this.linePayProcessing || this.linePayFailed;
    },
  },
  methods: {
    startFetchingOrderInfo() {
      this.orderInfoInterval = setInterval(async () => {
        if (this.fetchOrderInfo) {
          await this.getOrderInfo();
        }
      }, 5000);
    },
    stopFetchingOrderInfo() {
      if (this.orderInfoInterval) {
        clearInterval(this.orderInfoInterval);
        this.orderInfoInterval = null;
      }
    },
    async cancelOrder() {
      try {
        commonUtilities.createLoading("訂單取消中...");
        await this.$store.dispatch("order/cancelOnlineOrder");
        await commonUtilities.delay(1000);
        commonUtilities.closeLoading();
        this.paymentStatus = "userCancelled";
        commonUtilities.createToast("success", "訂單已取消");
        // TODO: 訂單頁應該使用最新的 order info 資料
        const res = await this.$store.dispatch("order/getOnlineOrders", [
          this.orderNumber,
        ]);
        console.log(res);
        // this.toMemberPage()
      } catch (e) {
        commonUtilities.createToast("error", "取消訂單失敗", `${e}`);
      }
    },
    async fetchLinePayConfirm() {
      console.log(this.linePayPaymentMethod);
      // 雲端列印：帶入建立訂單時組好的列印欄位（print_data + printer_serial）
      // 後端兩者同時存在且付款確認成功才會列印
      const printFields = this.$store.state.order.linePayPrintFields || {};
      await this.$store.dispatch("payment/linePayConfirm", {
        store_payment_methods_config_id:
          this.linePayPaymentMethod.store_payment_methods_config_id,
        orderId: this.routerQueryOrderNumber,
        transactionId: this.transactionId,
        ...printFields,
      });
      // cancel_print_data 只送第一次：呼叫成功送達後即從 state 移除，
      // 避免重新整理付款頁重新掛載時，再次送出付款失敗列印指令。
      if (printFields.cancel_print_data) {
        this.$store.commit("order/setLinePayPrintFields", {
          print_data: printFields.print_data,
          printer_serial: printFields.printer_serial,
        });
      }
    },
    async getOrderInfo() {
      try {
        const res = await this.$store.dispatch("order/getOnlineOrders", [
          this.orderNumber,
        ]);
        console.log("order info", res.data.data.online_order_info[0]);
        // 複寫 orderInfo
        this.orderInfo = res.data.data.online_order_info[0];
        this.loading = false;
        await commonUtilities.delay(300);
        if (this.showOrderCreateToast) {
          if (!this.onlinePaymentFailed) {
            commonUtilities.createToast("success", "訂單已成立");
          }
          // 只需要顯示一次
          this.$store.commit("order/setShowOrderCreateToast", false);
        }
      } catch (e) {
        await commonUtilities.delay(500);
        // commonUtilities.createToast("error", "訂單資訊讀取失敗", `${e}`)
      }
    },
    toMemberPage() {
      this.$router.replace({
        path: `/${this.storeCode}`,
      });
    },
    toLineOfficialAccount() {
      if (this.lineOfficialAddress) {
        window.location.href = this.lineOfficialAddress;
      }
    },
    toOrderConfirm() {
      // 重新支付會建立新訂單，不可帶回上一筆的 transactionId/orderId
      const cleanQuery = { ...this.$route.query };
      delete cleanQuery.transactionId;
      delete cleanQuery.orderId;
      this.$router.push({
        name: "ordering",
        params: {
          store: this.getUrlParameters.store,
          process: "orderConfirm",
          method: this.getUrlParameters.method,
          areaId: this.getUrlParameters.areaId,
          tableIndex: this.getUrlParameters.tableIndex,
        },
        query: cleanQuery,
      });
    },
  },
  beforeRouteLeave(to) {
    this.stopFetchingOrderInfo();
    if (to.name === "ordering") {
      console.log("===== 重新訂購 =====");
      return;
    }
    console.log("離開訂單付款頁面 刪除資料");
    // 刪除購物車資料
    // TODO: 使用 payment & cart store
    this.$store.commit("cart/setCart", []);
    this.$store.commit("cart/setSelectedCoupon", null);
    this.$store.commit("cart/setIsPointUsed", false);
    this.$store.commit("cart/setPoints", 0);
    this.$store.commit("order/setOrderNumber", "");
    this.$store.commit("order/setShowOrderCreateToast", true);
    // 清空 payment 資料
    this.$store.commit("cart/setPayment", {});
  },
};
</script>
<style lang="scss" scoped>
.order_list {
  margin-bottom: env(safe-area-inset-bottom);
  width: 100%;
  padding: 20px 0px;
  background-color: #fff;
  margin-top: 15px;
  border-radius: 6px;
  box-shadow: 0px 0px 8px 1px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: 0px 0px 8px 1px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0px 0px 8px 1px rgba(0, 0, 0, 0.1);
}

.order_list_detail {
  padding: 0% 6%;
}

.payment_type {
  border-radius: 30px;
  font-size: 16px;
  font-family: PingFang SC;
  color: #000;
  font-weight: 400;
  padding: 4px 13px;
  margin-right: 10px;
}

.total_price {
  width: 100%;
  margin: 15px 0 20px;
  padding: 20px 0;
  border-top: 1px dotted #000;
  border-bottom: 1px dotted #000;
  font-size: 18px;
}

.cancel_button {
  margin: 15px 0;
  padding: 8px;
  border-radius: 30px;
  background-color: #fff;
  border: none;
  color: #000;
  width: 82px;
  height: 36px;
  font-size: 14px;
  box-shadow: 0px 0px 8px 2px rgba(0, 0, 0, 0.14);
  -webkit-box-shadow: 0px 0px 8px 2px rgba(0, 0, 0, 0.14);
  -moz-box-shadow: 0px 0px 8px 2px rgba(0, 0, 0, 0.14);
}

.order_info {
  width: 100%;
  margin-bottom: 14px;
  font-size: 16px;
  color: #000;
  flex-shrink: 0;
  letter-spacing: 1px;

  .order_info_title {
    text-align: left;
    font-weight: 700;
    margin-right: 8px;
    color: #666666;
    flex-shrink: 0;
  }
}
</style>
